const styles = {
  scroll__wheel: {
    overflow: 'auto',
    height: '24.25em',
    position: ' relative',
    paddingLeft: '10%',
    paddingRight: '8%',
  },

  list__container: {
    display: 'flex',
    width: '100%',
  },

  info__container: {
    display: 'flex',
    flex: 1,
    paddingBottom: '1em',
  },

  title__text: {
    fontSize: '1.1em',
  },

  subtitle__text: {
    paddingLeft: '1.2em',
    fontSize: '1em',
  },

  hours__container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  reviews__container: {
    flexDirection: 'column',
    display: 'flex',
  },

  reviews__content: {
    paddingTop: '1em',
    fontWeight: '400px',
  },
};

export default styles;
